import classNames from 'classnames'
import htmlReactParser from 'html-react-parser'
import { isValidElement, ReactNode } from 'react'
import Card from 'react-bootstrap/Card'
import reactStringReplace from 'react-string-replace'
import YouTube from 'react-youtube'

import styles from './Description.module.scss'

type Props = {
  children: ReactNode
}

const Description = ({ children }: Props) => {
  if (!children) return null

  // Replace YouTube links with embedded videos
  const newChildren =
    typeof children === 'string'
      ? reactStringReplace(children, /https:\/\/www.youtube.com\/watch\?v=([\w-]+)/g, (match) => (
          <YouTube videoId={match} />
        ))?.map((child) => (isValidElement(child) ? child : child ? htmlReactParser(child as string) : null))
      : children

  return (
    <Card className={classNames(styles.description, 'shadow-sm')}>
      <Card.Body>{newChildren}</Card.Body>
    </Card>
  )
}

export default Description
